import {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Grid,
  MenuItem,
  Select,
  Chip,
  Typography,
  Link,
  InputAdornment,
  IconButton
} from '@mui/material';
import { useRegister } from '../../Contexts/RegisterProvider';
import { cellphone, cpf, formatDate, onlyNumber, rg, validateCpf, validateEmail } from '../../utils';
import { useApp } from '../../Contexts/AppProvider';
import { Close } from '@mui/icons-material';
import axios from 'axios';

interface ILider {
  value: string,
  subLideres?: {
    value: string
  }[]
}

export default function Registration() {
  const {data, saveInList, getData, saveData} = useRegister();
  const {setAlert} = useApp();
  const [lideres, setLideres] = useState<ILider[]>([]);

  const getLideres = async () => {
    const {data} = await axios.get(process.env.PUBLIC_URL+'/lideres.json');
    
    const parseLider: any[] = [];
    var groupedData: any = [];

    for (var it = 0; it < data.length; it++) {
      var item = data[it];
      if (!groupedData[item.lider])
        groupedData[item.lider] = [];
      groupedData[item.lider].push(item);
    }

    for (const key in groupedData) {
      const sublideres = groupedData[key].filter((l: any) => l?.sublider?.trim() !== key?.trim());
      const subliderValue = sublideres.map(({sublider}: any) => ({value: sublider}))
      parseLider.push(sublideres.length > 0 ? {value: key.trim(), subLideres: subliderValue} : {value: key.trim()})
    }

    setLideres(parseLider as ILider[]);
  }

  useEffect(() => {
    getLideres();
  }, [])

  return (
    <Box
      id='formRegistration'
      component="form"
      sx={{
        '& .MuiTextField-root': { mt: 1.5, mb: 1.5 },
        mt: 2,
        mb: 5
      }}
      noValidate
      autoComplete="off"
    >
      <Grid container spacing={4}>
        <Grid item xl={6} lg={6} md={6} xs={12}>
          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Qual é o seu nome?"
            value={data?.firstName}
            onChange={({target: {value}}) => saveData({firstName: value})}
          />
          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Qual é o seu sobrenome?"
            value={data?.lastName}
            onChange={({target: {value}}) => saveData({lastName: value})}
          />

          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Qual a sua data de nascimento?"
            value={data?.birthDate || ''}
            placeholder={'__/__/____'}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => saveData({birthDate: ''})}
                    edge="end"
                  >
                    <Close />
                  </IconButton>
                </InputAdornment>
            }}
            onChange={({target: {value}}) => saveData({birthDate: formatDate(value)})}
          />

          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Qual é o seu RG?"
            className='rg'
            placeholder=''
            value={data?.rg}
            onChange={({target: {value}}) => saveData({rg: rg(value)})}
            onBlur={({target: {value}}) => {
              if(value.length < 12){
                setAlert({type: 'error', message: 'Digite um RG válido.'});
                setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
              }
            }}
          />

          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Qual é o seu CPF?"
            placeholder=''
            value={data?.cpf}
            name='cpf'
            onBlur={({target: {value}}) => {
              if(!validateCpf(onlyNumber(value))){
                setAlert({type: 'error', message: 'Digite um CPF válido.'});
                setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
              }
            }}
            onChange={({target: {value}}) => saveData({cpf: cpf(value)})}
          />

          <TextField
            required
            fullWidth
            id="outlined-required"
            label="Digite aqui seu telefone"
            placeholder={''}
            value={data?.phone}
            onChange={({target: {value}}) => saveData({phone: cellphone(value)})}
            onBlur={({target: {value}}) => {
              if(value.length < 14){
                setAlert({type: 'error', message: 'Digite um número de telefone válido.'});
                setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
              }
            }}
          />
           
          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Digite seu e-mail?"
            type='email'
            value={data?.email}
            onChange={({target: {value}}) => saveData({email: value})}
            onBlur={({target: {value}}) => {
              if(!validateEmail(value)){
                setAlert({type: 'error', message: 'Digite um e-mail válido.'});
                setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
              }
            }}
          />
          
          {/* list */}
          <FormControl sx={{mt: 1, mb: 2}} fullWidth>
            <FormLabel id="demo-simple-select-label">Quem é a sua líder?</FormLabel>
            <SelectLider lideres={lideres} />
          </FormControl>

          <FormControl sx={{mt: 1, mb: 2}} fullWidth>
            <FormLabel id="demo-simple-select-label">Como você declara sua cor de pele?</FormLabel>
            <Select
              sx={{mt: 1}}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={getData(45)?.answer || '-1'}
              onChange={({target: {value}}) => saveInList([{
                index: 45, 
                question: 'Como você declara sua cor de pele?', 
                answer: value
              }])}
            >
              <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
              <MenuItem value={'Amarela'}>Amarela</MenuItem>
              <MenuItem value={'Branca'}>Branca</MenuItem>
              <MenuItem value={'Indígena'}>Indígena</MenuItem>
              <MenuItem value={'Parda'}>Parda</MenuItem>
              <MenuItem value={'Preta'}>Preta</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{mt: 1, mb: 2}} fullWidth>
            <FormLabel id="demo-simple-select-label">Qual é o seu estado civil?</FormLabel>
            <Select
              sx={{mt: 1}}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={getData(0)?.answer || '-1'}
              onChange={({target: {value}}) => saveInList([{
                index: 0, 
                question: 'Qual é o seu estado civil?', 
                answer: value
              }])}
            >
              <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
              <MenuItem value={'Solteira'}>Solteira</MenuItem>
              <MenuItem value={'Casada'}>Casada</MenuItem>
              <MenuItem value={'Viúva'}>Viúva</MenuItem>
              <MenuItem value={'Divorciada'}>Divorciada</MenuItem>
              <MenuItem value={'Juntada'}>Juntada</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{mt: 2, mb: 2}} fullWidth component="fieldset" variant="standard">
            <FormLabel component="legend">Você tem dependentes? (Ex: filhos, pais, etc.)</FormLabel>
            <VisibleInput
              onChange={(value: boolean) => {
                saveInList([{
                  index: 1,
                  question: 'Você tem dependentes? (Ex: filhos, pais, etc.)', 
                  answer: value ? 'sim' : 'não'
                }], value ? [] : [2,3])
              }}
              inputTrue={
                <>
                  <Chip sx={{width: 170}} label={`total de filhos: ${(parseInt(getData(2)?.answer as string) || 0) + (parseInt(getData(3)?.answer as string) || 0)}`} />
                  <Box>
                    <TextField
                      sx={{mr: 1}}
                      fullWidth
                      required
                      type="number"
                      id="outlined-required"
                      label="Quantos trabalham?"
                      value={getData(2)?.answer}
                      onChange={({target: {value}}) => {
                        saveInList([
                          {index: 2, question: 'Filhos: Quantos trabalham?', answer: value}
                        ])
                      }}
                    />
                    <TextField
                      required
                      fullWidth
                      type="number"
                      id="outlined-required"
                      label="Quantos não trabalham?"
                      value={getData(3)?.answer}
                      onChange={({target: {value}}) => {
                        saveInList([
                          {index: 3, question: 'Filhos: Quantos nāo trabalham?', answer: value}
                        ])
                      }}
                    />
                  </Box>
                </>
              }
            />
          </FormControl>

          <FormControl sx={{mt: 1, mb: 2}} fullWidth>
            <FormLabel id="demo-simple-select-label">Qual é o seu grau de instrução?</FormLabel>
            <Select
              sx={{mt: 1}}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={getData(4)?.answer || '-1'}
              onChange={({target: {value}}) => saveInList([{
                index: 4,
                question: 'Qual é o seu grau de instrução?', 
                answer: value
              }])}
            >
              <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
              <MenuItem value={'1° Ano ao 5° Ano'}>1° Ano ao 5° Ano</MenuItem>
              <MenuItem value={'6° Ano ao 9° Ano'}>6° Ano ao 9° Ano</MenuItem>
              <MenuItem value={'Ensino Médio'}>Ensino Médio</MenuItem>
              <MenuItem value={'Faculdade'}>Faculdade</MenuItem>
              <MenuItem value={'Não fiz escola'}>Não fiz escola</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{mt: 2}} component="fieldset" variant="standard">
            <FormLabel component="legend">Você possui comprovante de endereço? (conta de luz, água, gás, telefone no seu nome)</FormLabel>
            <VisibleInput 
              onChange={(value: boolean) => {
                saveInList([{
                  index: 46,
                  question: 'Você possui comprovante de endereço? (conta de luz, água, gás, telefone no seu nome)', 
                  answer: value ? 'sim' : 'não'
                }], value ? [] : [5])
              }}
              inputTrue={
                <TextField
                  fullWidth
                  required
                  id="outlined-required"
                  label="Qual é o seu endereço completo?"
                  value={getData(5)?.answer}
                  onChange={({target: {value}}) => saveInList([{
                    index: 5,
                    question: 'Qual é o seu endereço completo?', 
                    answer: value
                  }])}
                />
              }
            />         
          </FormControl>

          <FormControl fullWidth sx={{mt: 2}} component="fieldset" variant="standard">
            <FormLabel component="legend">Você possui conta bancária no seu nome?</FormLabel>
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  required
                  id="outlined-required"
                  label="Qual banco"
                  value={getData(6)?.answer}
                  onChange={({target: {value}}) => saveInList([{
                    index: 6,
                    question: 'conta bancária - Banco', 
                    answer: onlyNumber(value)
                  }])}
                />
              </Grid>
              <Grid item xl={4} lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  required
                  id="outlined-required"
                  label="Qual agência"
                  value={getData(7)?.answer}
                  onChange={({target: {value}}) => saveInList([{
                    index: 7,
                    question: 'conta bancária - Agência', 
                    answer: onlyNumber(value)
                  }])}
                />
              </Grid>
              <Grid item xl={4} lg={4} md={4} xs={12}>
                <TextField
                  fullWidth
                  required
                  id="outlined-required"
                  label="Número da conta"
                  value={getData(8)?.answer}
                  onChange={({target: {value}}) => saveInList([{
                    index: 8,
                    question: 'conta bancária - Número da conta', 
                    answer: onlyNumber(value)
                  }])}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth sx={{mt: 2}} component="fieldset" variant="standard">
            <FormLabel component="legend">Você mora de aluguel?</FormLabel>
            <VisibleInput 
              onChange={(value: boolean) => {
                saveInList([{
                  index: 47,
                  question: 'Você mora de aluguel?', 
                  answer: value ? 'sim' : 'não'
                }], value ? [] : [9])
              }}
              inputTrue={
                <TextField
                  fullWidth
                  required
                  id="outlined-required"
                  label="Quanto paga de aluguel por mês?"
                  value={getData(9)?.answer}
                  onChange={({target: {value}}) => saveInList([{
                    index: 9,
                    question: 'Quanto paga de aluguel por mês?', 
                    answer: value
                  }])}
                />
              }
            />         
          </FormControl>
        </Grid>

        <Grid item xl={6} lg={6} md={6} xs={12}>
          <FormControl fullWidth sx={{mt: 1, mb: 2}} component="fieldset" variant="standard">
            <FormLabel component="legend">Você já tem um negócio?</FormLabel>
            <VisibleInput
              onChange={(value: boolean) => {
                saveInList([{
                  index: 48,
                  question: 'Você já tem um negócio?', 
                  answer: value ? 'sim' : 'não'
                }], value
                  ? [27,28,29,30,31,32,33,34,35,36,37,38,39,40]
                  : [41,42,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26]
                )
              }}
              inputTrue={
                <Box>
                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Que tipo de negócio você tem?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(41)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 41,
                          question: 'Que tipo de negócio você tem?', 
                          answer: value
                        }], value !== 'Outros' ? [42] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Comida'}>Comida</MenuItem>
                      <MenuItem value={'Artesanato'}>Artesanato</MenuItem>
                      <MenuItem value={'Roupas/Bijuterias'}>Roupas/Bijuterias</MenuItem>
                      <MenuItem value={'Beleza (Cabelo/Manicure)'}>Beleza (Cabelo/Manicure)</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(41)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva qual tipo de negócio."
                        value={getData(42)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 42,
                          question: 'Escreva qual tipo de negócio.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>
                  
                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Quando você começou?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(11)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 11,
                          question: 'Quando você começou?', 
                          answer: value
                        }])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'faz 6 meses'}>faz 6 meses</MenuItem>
                      <MenuItem value={'faz entre 7 e 12 meses'}>faz entre 7 e 12 meses</MenuItem>
                      <MenuItem value={'faz entre 2 e 3 anos'}>faz entre 2 e 3 anos</MenuItem>
                      <MenuItem value={'faz entre 4 e 5 anos'}>faz entre 4 e 5 anos</MenuItem>
                      <MenuItem value={'faz 6 anos ou mais'}>faz 6 anos ou mais</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Como aprendeu o negócio que você faz?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(12)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 12,
                          question: 'Como aprendeu o negócio que você faz?', 
                          answer: value
                        }], value !== 'Outros' ? [13] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Sozinha'}>Sozinha</MenuItem>
                      <MenuItem value={'Família (Mãe/Avó)'}>Família (Mãe/Avó)</MenuItem>
                      <MenuItem value={'Cursos'}>Cursos</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(12)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva como aprendeu o negócio que você faz."
                        value={getData(13)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 13,
                          question: 'Escreva como aprendeu o negócio que você faz.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Onde funciona o seu negócio?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(14)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 14,
                          question: 'Onde funciona o seu negócio?', 
                          answer: value
                        }], value !== 'Outros' ? [15] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Na sua casa'}>Na sua casa</MenuItem>
                      <MenuItem value={'Na casa de um parente'}>Na casa de um parente</MenuItem>
                      <MenuItem value={'Na casa de uma amiga'}>Na casa de uma amiga</MenuItem>
                      <MenuItem value={'Na rua'}>Na rua</MenuItem>
                      <MenuItem value={'Aluguel de espaço'}>Aluguel de espaço</MenuItem>
                      <MenuItem value={'Outros'}>outros</MenuItem>
                    </Select>
                    {getData(14)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva onde funciona o seu negócio."
                        value={getData(15)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 15,
                          question: 'Escreva onde funciona o seu negócio.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Onde você vende os seus produtos ou serviços?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(16)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 16,
                          question: 'Onde você vende os seus produtos ou serviços?', 
                          answer: value
                        }], value !== 'Outros' ? [17] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Na sua casa'}>Na sua casa</MenuItem>
                      <MenuItem value={'Na feira'}>Na feira</MenuItem>
                      <MenuItem value={'Em lojas'}>Em lojas</MenuItem>
                      <MenuItem value={'De porta em porta'}>De porta em porta</MenuItem>
                      <MenuItem value={'Aluguel de espaço'}>Aluguel de espaço</MenuItem>
                      <MenuItem value={'Internet'}>Internet</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(16)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva onde você vende os seus produtos ou serviços."
                        value={getData(17)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 17,
                          question: 'Escreva onde você vende os seus produtos ou serviços.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Quantas pessoas trabalham com vocês?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(18)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 18,
                          question: 'Quantas pessoas trabalham com vocês?', 
                          answer: value
                        }])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Trabalho sozinha'}>Trabalho sozinha</MenuItem>
                      <MenuItem value={'de 1 a 3 pessoas'}>de 1 a 3 pessoas</MenuItem>
                      <MenuItem value={'de 4 a 6 pessoas'}>de 4 a 6 pessoas</MenuItem>
                      <MenuItem value={'7 pessoas ou mais'}>7 pessoas ou mais</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Qual foi o seu faturamento no mês passado? (o que recebeu antes de pagar as contas)</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(19)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 19,
                          question: 'Qual foi o seu faturamento no mês passado? (o que recebeu antes de pagar as contas)', 
                          answer: value
                        }])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'até R$ 50,00 por mês'}>até R$ 50,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 100,00 por mês'}>até R$ 100,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 300,00 por mês'}>até R$ 300,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 600,00 por mês'}>até R$ 600,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 1.000,00 por mês'}>até R$ 1.000,00 por mês</MenuItem>
                      <MenuItem value={'mais de R$ 1.000,00 por mês'}>mais de R$ 1.000,00 por mês</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Quais foram as suas despesas com o negócio no mês passado?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(20)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 20,
                          question: 'Quais foram as suas despesas com o negócio no mês passado?', 
                          answer: value
                        }])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'até R$ 50,00 por mês'}>até R$ 50,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 100,00 por mês'}>até R$ 100,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 300,00 por mês'}>até R$ 300,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 600,00 por mês'}>até R$ 600,00 por mês</MenuItem>
                      <MenuItem value={'até R$ 1.000,00 por mês'}>até R$ 1.000,00 por mês</MenuItem>
                      <MenuItem value={'mais de R$ 1.000,00 por mês'}>mais de R$ 1.000,00 por mês</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Qual é a maior dificuldade que você tem no seu negócio?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(21)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 21,
                          question: 'Qual é a maior dificuldade que você tem no seu negócio?', 
                          answer: value
                        }], value !== 'Outros' ? [22] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Vendas baixas'}>Vendas baixas</MenuItem>
                      <MenuItem value={'Como fazer as contas'}>Como fazer as contas</MenuItem>
                      <MenuItem value={'Ter lucro/Sobrar dinheiro'}>Ter lucro/Sobrar dinheiro</MenuItem>
                      <MenuItem value={'Preço do material'}>Preço do material</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(21)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva a maior dificuldade que você tem no seu negócio."
                        value={getData(22)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 22,
                          question: 'Escreva a maior dificuldade que você tem no seu negócio.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">No que você pretende gastar os R$ 2.000,00 que poderá receber do Fundo Dona de Mim?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(23)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 23,
                          question: 'No que você pretende gastar os R$ 2.000,00 que poderá receber do Fundo Dona de Mim?', 
                          answer: value
                        }], value !== 'Outros' ? [24] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Pagar as despesas de casa'}>Pagar as despesas de casa</MenuItem>
                      <MenuItem value={'Compra de matéria prima'}>Compra de matéria prima</MenuItem>
                      <MenuItem value={'Contratar funcionários'}>Contratar funcionários</MenuItem>
                      <MenuItem value={'Compra de equipamentos'}>Compra de equipamentos</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(23)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva como você pretende gastar os R$ 2.000,00."
                        value={getData(24)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 24,
                          question: 'Escreva como você pretende gastar os R$ 2.000,00.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>
                </Box>
              }
              inputFalse={
                <Box>
                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Qual é o negócio que você quer montar?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(27)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 27,
                          question: 'Qual é o negócio que você quer montar?', 
                          answer: value
                        }], value !== 'Outros' ? [28] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Comida'}>Comida</MenuItem>
                      <MenuItem value={'Artesanato'}>Artesanato</MenuItem>
                      <MenuItem value={'Roupas/Bijuterias'}>Roupas/Bijuterias</MenuItem>
                      <MenuItem value={'Beleza (Cabelo/Manicure)'}>Beleza (Cabelo/Manicure)</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(27)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva quais foram as suas despesas com o negócio no mês passado."
                        value={getData(28)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 28,
                          question: 'Escreva quais foram as suas despesas com o negócio no mês passado.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>
                  
                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Como aprendeu o negócio que você quer fazer?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(29)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 29,
                          question: 'Como aprendeu o negócio que você quer fazer?', 
                          answer: value
                        }], value !== 'Outros' ? [30] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Não aprendi'}>Não aprendi</MenuItem>
                      <MenuItem value={'Sozinha'}>Sozinha</MenuItem>
                      <MenuItem value={'Família (Mãe/Avó)'}>Família (Mãe/Avó)</MenuItem>
                      <MenuItem value={'Amigas'}>Amigas</MenuItem>
                      <MenuItem value={'Cursos'}>Cursos</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(29)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva como aprendeu o negócio que você quer fazer."
                        value={getData(30)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 30,
                          question: 'Escreva como aprendeu o negócio que você quer fazer.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Onde você quer montá-lo?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(31)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 31,
                          question: 'Onde você quer montá-lo?', 
                          answer: value
                        }], value !== 'Outros' ? [32] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Na sua casa'}>Na sua casa</MenuItem>
                      <MenuItem value={'Na casa de um parente'}>Na casa de um parente</MenuItem>
                      <MenuItem value={'Na casa de uma amiga'}>Na casa de uma amiga</MenuItem>
                      <MenuItem value={'Na rua'}>Na rua</MenuItem>
                      <MenuItem value={'Aluguel de espaço'}>Aluguel de espaço</MenuItem>
                      <MenuItem value={'Outros'}>outros</MenuItem>
                    </Select>
                    {getData(31)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva onde você quer montá-lo."
                        value={getData(32)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 32,
                          question: 'Escreva onde você quer montá-lo.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Onde você quer vender os seus produtos ou serviços?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(33)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 33,
                          question: 'Onde você quer vender os seus produtos ou serviços?', 
                          answer: value
                        }], value !== 'Outros' ? [34] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Na sua casa'}>Na sua casa</MenuItem>
                      <MenuItem value={'Na feira'}>Na feira</MenuItem>
                      <MenuItem value={'Em lojas'}>Em lojas</MenuItem>
                      <MenuItem value={'De porta em porta'}>De porta em porta</MenuItem>
                      <MenuItem value={'Aluguel de espaço'}>Aluguel de espaço</MenuItem>
                      <MenuItem value={'Internet'}>Internet</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(33)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva onde você quer vender os seus produtos ou serviços."
                        value={getData(34)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 34,
                          question: 'Escreva onde você quer vender os seus produtos ou serviços.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Quantas pessoas você vai precisar que trabalhe junto com você?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(35)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 35,
                          question: 'Quantas pessoas você vai precisar que trabalhe junto com você?', 
                          answer: value
                        }])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'vou trabalhar sozinha'}>Trabalho sozinha</MenuItem>
                      <MenuItem value={'de 1 a 3 pessoas'}>de 1 a 3 pessoas</MenuItem>
                      <MenuItem value={'de 4 a 6 pessoas'}>de 4 a 6 pessoas</MenuItem>
                      <MenuItem value={'7 pessoas ou mais'}>7 pessoas ou mais</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Qual é o valor que você vai precisar para começar o seu negócio?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(36)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 36,
                          question: 'Qual é o valor que você vai precisar para começar o seu negócio?', 
                          answer: value
                        }])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'até R$ 500,00'}>até R$ 500,00</MenuItem>
                      <MenuItem value={'até R$ 1.000,00'}>até R$ 1.000,00</MenuItem>
                      <MenuItem value={'até R$ 2.000,00'}>até R$ 2.000,00</MenuItem>
                      <MenuItem value={'mais de R$ 2.000,00'}>mais de R$ 2.000,00</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">Qual é a sua maior preocupação em ter seu próprio negócio?</FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(37)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 37,
                          question: 'Qual é a sua maior preocupação em ter seu próprio negócio?', 
                          answer: value
                        }], value !== 'Outros' ? [38] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Assumir dívidas'}>Assumir dívidas</MenuItem>
                      <MenuItem value={'Vendas baixas'}>Vendas baixas</MenuItem>
                      <MenuItem value={'Fazer as contas'}>Fazer as contas</MenuItem>
                      <MenuItem value={'Ter prejuízo'}>Ter prejuízo</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(37)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva a sua maior preocupação em ter seu próprio negócio."
                        value={getData(38)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 38,
                          question: 'Escreva a sua maior preocupação em ter seu próprio negócio.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>

                  <FormControl sx={{mt: 3}} fullWidth>
                    <FormLabel id="demo-simple-select-label">
                      No que você pretende gastar os R$ 2.000,00 que poderá receber do Fundo Dona de Mim?
                    </FormLabel>
                    <Select
                      sx={{mt: 1}}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={getData(39)?.answer || '-1'}
                      onChange={({target: {value}}) => {
                        saveInList([{
                          index: 39,
                          question: 'No que você pretende gastar os R$ 2.000,00 que poderá receber do Fundo Dona de Mim?', 
                          answer: value
                        }], value !== 'Outros' ? [40] : [])
                      }}
                    >
                      <MenuItem value={'-1'} disabled={true}>Selecionar</MenuItem>
                      <MenuItem value={'Pagar as despesas de casa'}>Pagar as despesas de casa</MenuItem>
                      <MenuItem value={'Compra de matéria prima'}>Compra de matéria prima</MenuItem>
                      <MenuItem value={'Contratar funcionários'}>Contratar funcionários</MenuItem>
                      <MenuItem value={'Compra de equipamentos'}>Compra de equipamentos</MenuItem>
                      <MenuItem value={'Outros'}>Outros</MenuItem>
                    </Select>
                    {getData(39)?.answer === 'Outros' && (
                      <TextField
                        fullWidth
                        required
                        id="outlined-required"
                        label="Escreva no que você pretende gastar os R$ 2.000,00 que poderá receber do Fundo Dona de Mim."
                        value={getData(40)?.answer}
                        onChange={({target: {value}}) => saveInList([{
                          index: 40,
                          question: 'Escreva no que você pretende gastar os R$ 2.000,00 que poderá receber do Fundo Dona de Mim.', 
                          answer: value
                        }])}
                      />
                    )}
                  </FormControl>
                </Box>
              }
            />
          </FormControl>

          <TextField
            fullWidth
            required
            id="outlined-required"
            label="Como você acredita que o Fundo Dona de Mim poderá te ajudar?"
            value={getData(43)?.answer}
            onChange={({target: {value}}) => saveInList([{
              index: 43,
              question: 'Como você acredita que o Fundo Dona de Mim poderá te ajudar?', 
              answer: value
            }])}
          />

          <Typography style={{marginTop: 15, fontSize: 20}}>
            Ao clicar em <strong>"Próximo"</strong> você concorda com nossos <Link href='https://mkt.n2app.com.br/donademimsigmatermodeusopoliticaprivacidadelgpd' target="_blank"><strong>Termos de uso e Privacidade LGPD</strong></Link>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

const VisibleInput = ({inputTrue, inputFalse, onChange}: any) => {
  const [visible, setVisible] = useState<boolean | null>(null);
  return (
    <>
      <RadioGroup sx={{alignItems: 'center', display: 'flex'}} row name="row-radio-buttons-group">
        <FormControlLabel
          value={false}
          checked={visible === false}
          control={<Radio />}
          label="Não"
          onChange={() => {
            setVisible(false);
            onChange?.(false);
          }}
        />
        <FormControlLabel
          value={true}
          checked={visible === true}
          control={<Radio />}
          label="Sim"
          onChange={() => {
            setVisible(true);
            onChange?.(true);
          }}
        />
      </RadioGroup>

      {visible === true && inputTrue}
      {visible === false && inputFalse}
    </>
  )
}

const SelectLider = ({lideres}: {lideres: ILider[]}) => {
  const {getData, saveInList} = useRegister();
  const [selectedLider, setSelectedLider] = useState<ILider>();

  return (
    <>
      <Select
        sx={{mt: 1}}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={getData(44)?.answer || '-1'}
        onChange={({target: {value}}) => {
          const lider = lideres?.find((lider) => lider.value === value);
          setSelectedLider(lider);
          saveInList([
            {
              index: 44,
              question: 'Quem é a sua líder?', 
              answer: value
            }
          ], [49])
        }}
      >
        <MenuItem value={'-1'} disabled={true}>Selecionar lider</MenuItem>
        {lideres?.map(({value}, index) => (<MenuItem key={value+index} value={value}>{value}</MenuItem>))}
      </Select>

      {selectedLider?.subLideres && (
        <Select
          sx={{mt: 1}}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={getData(49)?.answer || '-1'}
          onChange={({target: {value}}) => {
            saveInList([{
              index: 49,
              question: 'Quem é a sua sublíder?', 
              answer: value
            }])
          }}
        >
          <MenuItem value={'-1'} disabled={true}>Selecionar sublider</MenuItem>
          {selectedLider?.subLideres?.map(({value}) => (<MenuItem key={value} value={value}>{value}</MenuItem>))}
        </Select>
      )}
    </>
  )
}
